import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { defaultConfig } from "./default_config";
import { PivotControl } from "../../constants/pivot_control_options";
import { DatePivotParams } from "../../entities/date_pivot_params";
import { defaultChartViewerConfig } from "./default_chart_viewer_config";

export const SupplyNoPerspectiveContainer = () => {
  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "purchase_order_master",
        transformId: "purchase_order_master_date_pivot",
        folder: "outputs",
        title: "Supply",
        dateHierarchyColumnFilter: {
          purchase_order_week: "PO week",
          purchase_order_month: "PO month",
          eta_to_warehouse_week: "ETA week",
          eta_to_warehouse_month: "ETA month",
        },
        excludedSegmentationsFilter: [],
        measureColumnFilter: {
          quantity: "quantity",
          cost: "cost",
          // Schema-gated: only shown for customers whose purchase_order_master
          // carries these physical columns (currently Cora).
          pallets: "pallets",
          eaches: "eaches",
        },
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.DateHierarchy,
          PivotControl.DatePeriodPicker,
          PivotControl.FilterBy,
          PivotControl.Measure,
          PivotControl.SegmentSelectMulti,
          PivotControl.StoreAsDefault,
          PivotControl.Download,
          PivotControl.ShowSettings,
          PivotControl.EnableChartView,
        ],
        paramsToTransformArgs: (
          params: DatePivotParams
        ): Record<string, any> => {
          const transformArgs = {
            min_date: params.minDate,
            max_date: params.maxDate,
            date_field: params.dateHierarchy,
            value_field: params.measure,
            group_by_fields: params.segments || [],
            filters: params.filters || [],
          };
          return transformArgs;
        },
        shadeHistory: true,
        showHeaderRow: true,
      }}
      defaultConfig={defaultConfig}
      chartConfig={defaultChartViewerConfig}
    />
  );
};
